import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { AddressDetails } from "../smart-components/smart-component-property";
import { ComponentAdapterCounterParent } from "./component-adapter-counter-parent";

/**
 * Component adapter for counter heating
 */
export class ComponentAdapterCounterHeating
  extends ComponentAdapterCounterParent
  implements IComponentLoader
{
  private _volume: AddressDetails = null;
  private _power: AddressDetails = null;
  private _energyHeat: AddressDetails = null;

  /**
   * Get address about energy heat skill
   */
  get EnergyHeat(): AddressDetails {
    return this._energyHeat;
  }

  /**
   * Get address about volume skill
   */
  get Volume(): AddressDetails {
    return this._volume;
  }

  /**
   * Get address about power skill
   */
  get Power(): AddressDetails {
    return this._power;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    data: SmartComponentSummaryData
  ): void {
    this._summary = data.summary;
    this._idSmartComponentKind = data.idSmartComponentKind;
    this._idEnvironment = data.idEnvironment;
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HEATING_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HEATING_DESCRIPTION
      )?.value || "";
    this._volume =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HEATING_VOLUME
      )?.address || null;
    this._power =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HEATING_POWER
      )?.address || null;
    this._energyHeat =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HEATING_ENERGY_HEAT
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {}

  public fillAddressState(): void {}
}
